import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useLanguage } from '../context/LanguageContext';

const Leadership = () => {
    const { language } = useLanguage();
    const [expandedCard, setExpandedCard] = useState(null);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    const content = {
        en: {
            title: "Leadership",
            leaders: [
                {
                    name: "Hon'ble Thiru C. Joseph Vijay",
                    designation: "Hon'ble Chief Minister of Tamil Nadu",
                    department: "",
                    hasImage: true,
                    image: "/Images/tn-cm.png",
                    brief: "Hon'ble Thiru C. Joseph Vijay serves as the Chief Minister of Tamil Nadu, providing visionary leadership to the state. His commitment to public welfare and the cooperative movement drives initiatives that empower citizens and strengthen Tamil Nadu's social and economic fabric."
                },
                {
                    name: "Hon'ble Thiru V. Gandhiraj",
                    designation: "Hon'ble Minister for Co-operation",
                    department: "",
                    hasImage: true,
                    image: "/Images/tn-coop.png",
                    brief: "Hon'ble Thiru V. Gandhiraj serves as the Minister for Co-operation, Government of Tamil Nadu. He spearheads policies and programs that strengthen cooperative societies, empower farmers and members, and expand the reach of cooperative services across the state."
                },
                {
                    name: "Tmt. P. Amudha, I.A.S.",
                    designation: "Additional Chief Secretary to Government",
                    department: "Cooperation, Food and Consumer Protection Department",
                    hasImage: false,
                    brief: "As Additional Chief Secretary, Tmt. P. Amudha, I.A.S. provides strategic direction to the Cooperation, Food and Consumer Protection Department. Her administrative expertise ensures effective implementation of government schemes and policies that benefit cooperative societies and their members across Tamil Nadu."
                },
                {
                    name: "Tmt. G. Latha, I.A.S.",
                    designation: "Registrar of Cooperative Societies",
                    department: "Tamil Nadu",
                    hasImage: false,
                    brief: "Tmt. G. Latha, I.A.S., as the Registrar of Cooperative Societies, plays a pivotal role in regulating and promoting cooperative societies in Tamil Nadu. She oversees registration, auditing, and dispute resolution while fostering the growth and sustainability of the cooperative movement in the state."
                }
            ]
        },
        ta: {
            title: "தலைமை",
            leaders: [
                {
                    name: "மாண்புமிகு திரு சி. ஜோசப் விஜய்",
                    designation: "மாண்புமிகு தமிழ்நாடு முதலமைச்சர்",
                    department: "",
                    hasImage: true,
                    image: "/images/tn-cm.png",
                    brief: "மாண்புமிகு திரு சி. ஜோசப் விஜய் அவர்கள் தமிழ்நாட்டின் முதலமைச்சராகப் பணியாற்றி, மாநிலத்திற்கு தொலைநோக்கு தலைமைத்துவத்தை வழங்குகிறார். பொதுநல மற்றும் கூட்டுறவு இயக்கத்தின் மீதான அவரது அர்ப்பணிப்பு, குடிமக்களை வலுப்படுத்தும் மற்றும் தமிழ்நாட்டின் சமூக மற்றும் பொருளாதார கட்டமைப்பை வலுப்படுத்தும் முயற்சிகளை இயக்குகிறது."
                },
                {
                    name: "மாண்புமிகு திரு வி. காந்திராஜ்",
                    designation: "மாண்புமிகு கூட்டுறவுத் துறை அமைச்சர்",
                    department: "",
                    hasImage: true,
                    image: "/images/tn-coop.png",
                    brief: "மாண்புமிகு திரு வி. காந்திராஜ் அவர்கள் தமிழ்நாடு அரசின் கூட்டுறவுத் துறை அமைச்சராகப் பணியாற்றுகிறார். கூட்டுறவு சங்கங்களை வலுப்படுத்தும், விவசாயிகள் மற்றும் உறுப்பினர்களை மேம்படுத்தும், மற்றும் மாநிலம் முழுவதும் கூட்டுறவு சேவைகளை விரிவாக்கும் கொள்கைகள் மற்றும் திட்டங்களை அவர் முன்னெடுக்கிறார்."
                },
                {
                    name: "திருமதி. பி. அமுதா, இ.ஆ.ப.",
                    designation: "அரசின் கூடுதல் தலைமைச் செயலாளர்",
                    department: "கூட்டுறவு, உணவு மற்றும் நுகர்வோர் பாதுகாப்புத் துறை",
                    hasImage: false,
                    brief: "கூடுதல் தலைமைச் செயலாளராக, திருமதி. பி. அமுதா, இ.ஆ.ப. அவர்கள் கூட்டுறவு, உணவு மற்றும் நுகர்வோர் பாதுகாப்புத் துறைக்கு மூலோபாய வழிகாட்டுதலை வழங்குகிறார். அவரது நிர்வாக நிபுணத்துவம் கூட்டுறவு சங்கங்கள் மற்றும் தமிழ்நாடு முழுவதும் அவற்றின் உறுப்பினர்களுக்குப் பயனளிக்கும் அரசு திட்டங்கள் மற்றும் கொள்கைகளை திறம்பட செயல்படுத்துவதை உறுதிசெய்கிறது."
                },
                {
                    name: "திருமதி. ஜி. லதா, இ.ஆ.ப.",
                    designation: "கூட்டுறவுச் சங்கங்கள் பதிவாளர்",
                    department: "தமிழ்நாடு",
                    hasImage: false,
                    brief: "கூட்டுறவு சங்கங்களின் பதிவாளராக திருமதி. ஜி. லதா, இ.ஆ.ப. அவர்கள் தமிழ்நாட்டில் கூட்டுறவு சங்கங்களை ஒழுங்குபடுத்துவதிலும் மேம்படுத்துவதிலும் முக்கிய பங்கு வகிக்கிறார். அவர் பதிவு, தணிக்கை மற்றும் தகராறு தீர்வுகளை மேற்பார்வையிடுகிறார், அதே நேரத்தில் மாநிலத்தில் கூட்டுறவு இயக்கத்தின் வளர்ச்சி மற்றும் நிலைத்தன்மையை வளர்க்கிறார்."
                }
            ]
        }
    };

    const t = content[language];

    return (
        <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>

            {/* Leadership Section */}
            <section className="py-8" style={{ backgroundColor: '#f2f2f2' }}>
                <div className="container mx-auto px-4">
                    {/* Header */}
                    <div className="text-center mb-6">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
                            {t.title}
                        </h2>
                        <div className="w-20 h-1 bg-gray-800 mx-auto"></div>
                    </div>

                    {/* Leadership Cards */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-7xl mx-auto">
                        {t.leaders.map((leader, index) => (
                            <div
                                key={index}
                                className="shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-300 overflow-hidden"
                                onClick={() => toggleCard(index)}
                            >
                                {/* Card Header */}
                                <div className="bg-gradient-to-r from-[#005A8D] to-[#006AA5] p-4">
                                    <div className="flex items-center gap-4">

                                        {leader.hasImage && leader.image && (
                                            <div className="flex-shrink-0">
                                                <img
                                                    src={leader.image}
                                                    alt={leader.name}
                                                    className="w-20 h-20 rounded-full object-cover border-2 border-white"
                                                />
                                            </div>
                                        )}

                                        {/* Details Section */}
                                        <div className="flex-grow min-h-0">
                                            <h3 className="text-lg font-bold text-white leading-tight">{leader.name}</h3>
                                            <p className="text-sm font-semibold text-white/90 uppercase tracking-wide leading-tight mt-1">
                                                {leader.designation}
                                            </p>
                                            {leader.department && (
                                                <p className="text-sm text-white/80 leading-tight mt-1">
                                                    {leader.department}
                                                </p>
                                            )}
                                        </div>

                                        {/* Expand Icon */}
                                        <div className="flex-shrink-0">
                                            <div className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                                                {expandedCard === index ? (
                                                    <ChevronUp className="w-5 h-5 text-white" />
                                                ) : (
                                                    <ChevronDown className="w-5 h-5 text-white" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Expandable Brief */}
                                {expandedCard === index && (
                                    <div className="p-4 bg-gray-50 border-t border-gray-200">
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            {leader.brief}
                                        </p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Leadership;